import React from "react";
import Header from "../Header/Header";
import Navbar from "../Header/Navbar";
import AccountSidebar from "./AccountSidebar";
const AccountStatementComponent = () => {
  return (
    <div>
      <Header />
      <Navbar />
      <div className="">
        <div className="account_main    bg-[#f0ece1]  mt-1 flex">
          <AccountSidebar />
          <div className="balance_overview  w-[60%]  ml-3 ">
            <h2 className="font-bold">Account Statement</h2>
            <div className="bg-white px-2 py-[6px] mt-2">
              <div className="balance_cart  shadow-md hover:shadow-lg  bg-[#e0e6e6] p-2 ">
                <div className="flex">
                  <p className="text-[12px]">Period</p>
                  <input
                    type="date"
                    className="mx-2 px-2"
                    id="birthday"
                    name="birthday"
                  ></input>
                  <p className="">To</p>
                  <input type="date" className="mx-2 px-2"></input>
                  <input type="text" className="w-[60px]" placeholder="9:00" />
                </div>
                <div className="mt-2">
                  <button
                    className="text-[12px]  rounded px-3 mt-2 font-medium
              bg-[#fff]
          "
                  >
                    Just For Today
                  </button>
                  <button
                    className="text-[12px]  mx-3 rounded px-3 mt-2 font-medium
              bg-[#fff]
          "
                  >
                    Just For Today
                  </button>
                  <button
                    className="text-[12px]  mx-3 rounded px-3 mt-2 font-medium
              bg-[#000] text-yellow-400
          "
                  >
                    Get Statement
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountStatementComponent;
